module.exports = __webpack_public_path__ + "img/gb-web.b2b78725.webp";